module.exports = require("vue");


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = 2
// module chunks = 0